/**
 * @generated SignedSource<<e74a5499115cf583d7e982e5710ac02f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateReportTemplateByIdInput = {
  clientMutationId?: string | null;
  id: string;
  patch: ReportTemplatePatch;
};
export type ReportTemplatePatch = {
  config?: any | null;
  createdAt?: any | null;
  deletedAt?: any | null;
  description?: string | null;
  name?: string | null;
  organizationId?: any | null;
  rowId?: any | null;
  updatedAt?: any | null;
};
export type useReportTemplateUpdateMutation$variables = {
  input: UpdateReportTemplateByIdInput;
};
export type useReportTemplateUpdateMutation$data = {
  readonly updateReportTemplateById: {
    readonly reportTemplate: {
      readonly rowId: any;
      readonly id: string;
      readonly name: string | null;
      readonly config: any | null;
      readonly organizationId: any;
    } | null;
  } | null;
};
export type useReportTemplateUpdateMutation = {
  variables: useReportTemplateUpdateMutation$variables;
  response: useReportTemplateUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateReportTemplatePayload",
    "kind": "LinkedField",
    "name": "updateReportTemplateById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReportTemplate",
        "kind": "LinkedField",
        "name": "reportTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "config",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportTemplateUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportTemplateUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1728dc3256c649c2c58b01d7959eb4aa",
    "id": null,
    "metadata": {},
    "name": "useReportTemplateUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useReportTemplateUpdateMutation(\n  $input: UpdateReportTemplateByIdInput!\n) {\n  updateReportTemplateById(input: $input) {\n    reportTemplate {\n      rowId\n      id\n      name\n      config\n      organizationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "659baa724e466ed07e3b51bd96e0580d";

export default node;
